
enum ICustomerType {
    DirectSeller = 1,
    Marketplace = 2
}

export default ICustomerType;